export { WiredMigrateToZillow } from './MigrateToZillow.wired';
